webpackJsonp([35783957827783],{

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(31);
	
	var _utils = __webpack_require__(29);
	
	var _withTouchListeners = __webpack_require__(129);
	
	var _withTouchListeners2 = _interopRequireDefault(_withTouchListeners);
	
	var _StyleSheet = __webpack_require__(127);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollLock = function (_PureComponent) {
	  _inherits(ScrollLock, _PureComponent);
	
	  function ScrollLock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollLock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.getStyles = function () {
	      var accountForScrollbars = _this.props.accountForScrollbars;
	
	
	      var height = (0, _utils.getDocumentHeight)();
	      var paddingRight = accountForScrollbars ? (0, _utils.getPadding)() : null;
	      var styles = 'body {\n      box-sizing: border-box !important;\n      overflow: hidden !important;\n      position: relative !important;\n      ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n      ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n    }';
	
	      return styles;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScrollLock, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_exenv.canUseDOM) return;
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var offset = window.innerHeight - this.initialHeight;
	
	      // adjust scroll if the window has been resized since the lock was engaged
	      // e.g. mobile safari dynamic chrome heights
	      if (offset) {
	        window.scrollTo(0, window.pageYOffset + offset);
	      }
	
	      // reset the initial height in case this scroll lock is used again
	      this.initialHeight = window.innerHeight;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_StyleSheet2.default, { styles: this.getStyles() });
	    }
	  }]);
	
	  return ScrollLock;
	}(_react.PureComponent);
	
	ScrollLock.defaultProps = {
	  accountForScrollbars: true
	};
	exports.default = (0, _withTouchListeners2.default)(ScrollLock);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(31);
	
	var _utils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sheet = function (_PureComponent) {
	  _inherits(Sheet, _PureComponent);
	
	  function Sheet() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Sheet);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sheet.__proto__ || Object.getPrototypeOf(Sheet)).call.apply(_ref, [this].concat(args))), _this), _this.addSheet = function () {
	      var styles = _this.props.styles;
	
	
	      var sheet = (0, _utils.makeStyleTag)();
	      if (!sheet) return;
	
	      (0, _utils.injectStyles)(sheet, styles);
	      (0, _utils.insertStyleTag)(sheet);
	
	      _this.sheet = sheet;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Sheet, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_exenv.canUseDOM) return;
	      this.addSheet();
	    }
	  }, {
	    key: 'removeSheet',
	    value: function removeSheet() {
	      if (!this.sheet) return;
	
	      // $FlowFixMe
	      this.sheet.parentNode.removeChild(this.sheet);
	      this.sheet = null;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeSheet();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Sheet;
	}(_react.PureComponent);
	
	exports.default = Sheet;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ScrollLock = __webpack_require__(126);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollLock).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.preventTouchMove = preventTouchMove;
	exports.allowTouchMove = allowTouchMove;
	exports.preventInertiaScroll = preventInertiaScroll;
	exports.isTouchDevice = isTouchDevice;
	exports.getPadding = getPadding;
	exports.camelToKebab = camelToKebab;
	exports.getWindowHeight = getWindowHeight;
	exports.getDocumentHeight = getDocumentHeight;
	exports.parse = parse;
	exports.makeStyleTag = makeStyleTag;
	exports.injectStyles = injectStyles;
	exports.insertStyleTag = insertStyleTag;
	function preventTouchMove(e) {
	  e.preventDefault();
	}
	
	function allowTouchMove(e) {
	  e.stopPropagation();
	}
	
	function preventInertiaScroll() {
	  var top = this.scrollTop;
	  var totalScroll = this.scrollHeight;
	  var currentScroll = top + this.offsetHeight;
	
	  if (top === 0) {
	    this.scrollTop = 1;
	  } else if (currentScroll === totalScroll) {
	    this.scrollTop = top - 1;
	  }
	}
	
	// `ontouchstart` check works on most browsers
	// `maxTouchPoints` works on IE10/11 and Surface
	function isTouchDevice() {
	  if (typeof window === 'undefined' || !window) return false;
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}
	
	function getPadding() {
	  if (typeof window === 'undefined' || !window || !document) return 0;
	
	  var currentPadding = parseInt(document.body.paddingRight, 10) || 0;
	  var clientWidth = document.body ? document.body.clientWidth : 0;
	  var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
	
	  return adjustedPadding;
	}
	
	function camelToKebab(str) {
	  return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	
	function getWindowHeight() {
	  var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	  if (typeof window !== 'undefined' && window && window.innerHeight) {
	    return window.innerHeight * multiplier;
	  }
	}
	
	function getDocumentHeight() {
	  if (typeof window !== 'undefined' && document && document.body) {
	    return document.body.clientHeight;
	  }
	}
	
	function parse(val) {
	  return isNaN(val) ? val : val + 'px';
	}
	
	// ==============================
	// Style Sheets
	// ==============================
	
	function makeStyleTag(id) {
	  var tag = document.createElement('style');
	  tag.type = 'text/css';
	  tag.setAttribute('data-react-scrolllock', '');
	
	  return tag;
	}
	function injectStyles(tag, css) {
	  if (tag.styleSheet) {
	    tag.styleSheet.cssText = css;
	  } else {
	    tag.appendChild(document.createTextNode(css));
	  }
	}
	function insertStyleTag(tag) {
	  var head = document.head || document.getElementsByTagName('head')[0];
	  head.appendChild(tag);
	}

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = withTouchListeners;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(31);
	
	var _utils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withTouchListeners(WrappedComponent) {
	  return function (_PureComponent) {
	    _inherits(TouchProvider, _PureComponent);
	
	    function TouchProvider() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, TouchProvider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).call.apply(_ref, [this].concat(args))), _this), _this.listenerOptions = {
	        capture: false,
	        passive: false
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(TouchProvider, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // account for touch devices
	        if (target && (0, _utils.isTouchDevice)()) {
	          // Mobile Safari ignores { overflow: hidden } declaration on the body.
	          target.addEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          // Allow scroll on provided target
	          if (touchScrollTarget) {
	            touchScrollTarget.addEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.addEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!_exenv.canUseDOM) return;
	
	        var touchScrollTarget = this.props.touchScrollTarget;
	
	        var target = document.body;
	
	        // remove touch listeners
	        if (target && (0, _utils.isTouchDevice)()) {
	          target.removeEventListener('touchmove', _utils.preventTouchMove, this.listenerOptions);
	
	          if (touchScrollTarget) {
	            touchScrollTarget.removeEventListener('touchstart', _utils.preventInertiaScroll, this.listenerOptions);
	            touchScrollTarget.removeEventListener('touchmove', _utils.allowTouchMove, this.listenerOptions);
	          }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	    }]);
	
	    return TouchProvider;
	  }(_react.PureComponent);
	}

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    background-image: linear-gradient(\n        -24deg,\n        ', ',\n        ', '\n    );\n    clip-path: polygon(0% 0%, 100% 0px, 100% 100%, 0px 95%);\n    min-height: 28rem;\n    text-shadow: rgba(0, 0, 0, 0.376) 0px 1px 2px;\n    will-change: clip-path;\n    ', ' {\n        clip-path: polygon(0% 0%, 100% 0px, 100% 100%, 0px 90%);\n    }\n'], ['\n    background-image: linear-gradient(\n        -24deg,\n        ', ',\n        ', '\n    );\n    clip-path: polygon(0% 0%, 100% 0px, 100% 100%, 0px 95%);\n    min-height: 28rem;\n    text-shadow: rgba(0, 0, 0, 0.376) 0px 1px 2px;\n    will-change: clip-path;\n    ', ' {\n        clip-path: polygon(0% 0%, 100% 0px, 100% 100%, 0px 90%);\n    }\n']);
	
	var _designSystem = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Section.extend(_templateObject, (0, _designSystem.cx)('cyan.6'), (0, _designSystem.cx)('teal.6'), function (_ref) {
	    var theme = _ref.theme;
	    return theme.mediaQueries.md;
	});
	
	var Intro = function Intro(props) {
	    return _react2.default.createElement(
	        Base,
	        props,
	        _react2.default.createElement(
	            _designSystem.Heading.h1,
	            { f: 7 },
	            'Let\u2019s get shipping!'
	        ),
	        _react2.default.createElement(
	            _designSystem.Text,
	            { f: 4, mt: 3 },
	            'Share your latest project with other hackers in the community.'
	        )
	    );
	};
	
	exports.default = Intro;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CloseButton = exports.Overlay = exports.Overlayer = exports.Modal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    0% {\n        transform: translate(-50%, -50%) scale(0);\n    }\n    85% {\n        transform: translate(-50%, -50%) scale(1.025);\n    }\n    100% {\n        transform: translate(-50%, -50%) scale(1);\n    }\n'], ['\n    0% {\n        transform: translate(-50%, -50%) scale(0);\n    }\n    85% {\n        transform: translate(-50%, -50%) scale(1.025);\n    }\n    100% {\n        transform: translate(-50%, -50%) scale(1);\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.0625), 0 16px 32px rgba(0, 0, 0, 0.125) !important;\n    left: 50%;\n    max-height: 95vh;\n    max-width: 95vw;\n    margin: 0 auto;\n    overflow-y: auto;\n    position: fixed;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: ', ';\n    z-index: 1100;\n    -webkit-overflow-scrolling: touch;\n    ', ' {\n        animation: ', ' ease-in 0.25s;\n    }\n    & > button:first-child {\n        position: fixed;\n        right: 0;\n        top: 0;\n    }\n'], ['\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.0625), 0 16px 32px rgba(0, 0, 0, 0.125) !important;\n    left: 50%;\n    max-height: 95vh;\n    max-width: 95vw;\n    margin: 0 auto;\n    overflow-y: auto;\n    position: fixed;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: ', ';\n    z-index: 1100;\n    -webkit-overflow-scrolling: touch;\n    ', ' {\n        animation: ', ' ease-in 0.25s;\n    }\n    & > button:first-child {\n        position: fixed;\n        right: 0;\n        top: 0;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    backdrop-filter: blur(6px);\n    background-color: rgba(255, 255, 255, 0.75);\n    height: 100%;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 1024;\n'], ['\n    backdrop-filter: blur(6px);\n    background-color: rgba(255, 255, 255, 0.75);\n    height: 100%;\n    left: 0;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 1024;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n    appearance: none;\n    background: transparent;\n    border: 0;\n    border-radius: ', ';\n    cursor: pointer;\n'], ['\n    appearance: none;\n    background: transparent;\n    border: 0;\n    border-radius: ', ';\n    cursor: pointer;\n']);
	
	var _reactFontawesome = __webpack_require__(25);
	
	var _designSystem = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactScrolllock = __webpack_require__(128);
	
	var _reactScrolllock2 = _interopRequireDefault(_reactScrolllock);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Sheet = __webpack_require__(102);
	
	var _Sheet2 = _interopRequireDefault(_Sheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var modalKeyframes = (0, _styledComponents.keyframes)(_templateObject);
	
	var Modal = exports.Modal = (0, _styledComponents2.default)(_Sheet2.default).attrs({ bg: 'white' })(_templateObject2, function (props) {
	    return props.w || props.width || '36rem';
	}, function (_ref) {
	    var theme = _ref.theme;
	    return theme.mediaQueries.md;
	}, modalKeyframes);
	
	var Overlayer = exports.Overlayer = (0, _styledComponents2.default)(_designSystem.Box)(_templateObject3);
	
	var Overlay = exports.Overlay = function Overlay(props) {
	    return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(Overlayer, props),
	        _react2.default.createElement(_reactScrolllock2.default, null)
	    );
	};
	
	var ButtonReset = (0, _styledComponents2.default)(_designSystem.Box.withComponent('button')).attrs({
	    p: 3,
	    role: 'button'
	})(_templateObject4, function (_ref2) {
	    var theme = _ref2.theme;
	    return theme.pill;
	});
	var CloseButton = exports.CloseButton = function CloseButton(props) {
	    return _react2.default.createElement(
	        ButtonReset,
	        _extends({ 'aria-label': 'Close', color: 'muted' }, props),
	        _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: 'times' })
	    );
	};

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    width: 100%;\n    ', ' {\n        width: 50%;\n    }\n    ', ' {\n        width: 33.3333%;\n    }\n'], ['\n    width: 100%;\n    ', ' {\n        width: 50%;\n    }\n    ', ' {\n        width: 33.3333%;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    position: relative;\n'], ['\n    position: relative;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    background-color: ', ';\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: ', ' ', ' 0 0;\n    display: block;\n    margin: 0;\n    padding-top: 66.6666%;\n    position: relative;\n'], ['\n    background-color: ', ';\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: ', ' ', ' 0 0;\n    display: block;\n    margin: 0;\n    padding-top: 66.6666%;\n    position: relative;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n    & ', ' {\n        vertical-align: top;\n    }\n    & > a:not(:first-child) {\n        margin-left: ', 'px;\n    }\n'], ['\n    & ', ' {\n        vertical-align: top;\n    }\n    & > a:not(:first-child) {\n        margin-left: ', 'px;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    cursor: pointer;\n    &:hover {\n        text-decoration: underline;\n    }\n'], ['\n    cursor: pointer;\n    &:hover {\n        text-decoration: underline;\n    }\n']);
	
	var _reactFontawesome = __webpack_require__(25);
	
	var _designSystem = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(100);
	
	var _UserCard = __webpack_require__(103);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Flex.extend.attrs({ p: 2 })(_templateObject, function (_ref) {
	    var theme = _ref.theme;
	    return theme.mediaQueries.sm;
	}, function (_ref2) {
	    var theme = _ref2.theme;
	    return theme.mediaQueries.lg;
	});
	
	var Inner = _designSystem.Card.withComponent(_designSystem.Flex).extend.attrs({
	    boxShadowSize: 'sm',
	    bg: 'snow',
	    color: 'black',
	    flexDirection: 'column',
	    w: 1
	})(_templateObject2);
	
	var Photo = _designSystem.Box.extend.attrs({
	    style: function style(props) {
	        return {
	            backgroundImage: 'url(' + props.src + ')'
	        };
	    }
	})(_templateObject3, (0, _designSystem.cx)('gray.1'), function (_ref3) {
	    var theme = _ref3.theme;
	    return theme.radius;
	}, function (_ref4) {
	    var theme = _ref4.theme;
	    return theme.radius;
	});
	
	var Info = _designSystem.Flex.withComponent(_gatsbyLink2.default).extend.attrs({
	    flex: 1,
	    flexDirection: 'column',
	    justify: 'flex-start',
	    p: 3
	})(_templateObject4);
	
	var Creators = _designSystem.Flex.extend.attrs({ bg: 'gray.1', p: 2 })(_templateObject5, _designSystem.Avatar, function (_ref5) {
	    var theme = _ref5.theme;
	    return theme.space[1];
	});
	
	var HiddenCreatorCount = _designSystem.Text.span.extend.attrs({
	    color: 'muted',
	    f: 1,
	    ml: 1
	})(_templateObject6);
	
	var ViewAllCreators = function (_Component) {
	    _inherits(ViewAllCreators, _Component);
	
	    function ViewAllCreators() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ViewAllCreators);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { active: false }, _this.toggleActive = function () {
	            _this.setState(function (state) {
	                return { active: !state.active };
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    ViewAllCreators.prototype.render = function render() {
	        var creators = this.props.creators;
	
	        var hiddenCreatorCount = creators.length - 4;
	        return _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(
	                HiddenCreatorCount,
	                { onClick: this.toggleActive },
	                '+ ',
	                hiddenCreatorCount,
	                ' other',
	                hiddenCreatorCount > 1 ? 's' : ''
	            ),
	            this.state.active && _react2.default.createElement(
	                _react.Fragment,
	                null,
	                _react2.default.createElement(
	                    _Modal.Modal,
	                    { align: 'left', my: 4, p: [3, 4], width: '32rem' },
	                    _react2.default.createElement(_Modal.CloseButton, { onClick: this.toggleActive }),
	                    _react2.default.createElement(
	                        _designSystem.Heading.h2,
	                        { mb: 3 },
	                        'Creators'
	                    ),
	                    creators.map(function (creator) {
	                        return _react2.default.createElement(_UserCard2.default, { data: creator, key: creator.id });
	                    })
	                ),
	                _react2.default.createElement(_Modal.Overlay, { onClick: this.toggleActive })
	            )
	        );
	    };
	
	    return ViewAllCreators;
	}(_react.Component);
	
	var sampleData = {
	    id: 1,
	    name: 'Hack Club',
	    slug: 'hack-club',
	    main_image: {
	        id: 1,
	        url: 'https://ph-files.imgix.net/844b9bf2-f927-45fd-a231-d13ba092efa1'
	    },
	    tagline: 'Hack Club is a nonprofit network of computer science clubs where members learn to code through tinkering and building projects.',
	    description: '',
	    created_at: '',
	    updated_at: '',
	    creators: [{
	        id: 1,
	        username: 'zrl',
	        name: 'Zach Latta',
	        avatar_url: 'https://hackclub.com/team/zach.jpg'
	    }, {
	        id: 2,
	        username: 'msw',
	        name: 'Max Wofford',
	        avatar_url: 'https://hackclub.com/team/max.jpg'
	    }, {
	        id: 3,
	        username: 'lachlanjc',
	        name: 'Lachlan Campbell',
	        avatar_url: 'https://hackclub.com/team/lachlan.jpg'
	    }, {
	        id: 4,
	        username: 'athul',
	        name: 'Athul Blesson',
	        avatar_url: 'https://hackclub.com/team/athul.jpg'
	    }, {
	        id: 5,
	        username: 'itsmingjie',
	        name: 'Mingjie Jiang',
	        avatar_url: 'https://hackclub.com/team/mingjie.jpg'
	    }, {
	        id: 6,
	        username: 'orpheus',
	        name: 'Prophet Orpheus',
	        avatar_url: 'https://hackclub.com/team/orpheus.jpg'
	    }],
	    images: [{
	        id: 1,
	        url: 'https://ph-files.imgix.net/844b9bf2-f927-45fd-a231-d13ba092efa1'
	    }],
	    links: [],
	    topics: []
	};
	
	var ProjectCard = function ProjectCard(_ref6) {
	    var _ref6$data = _ref6.data,
	        data = _ref6$data === undefined ? sampleData : _ref6$data,
	        props = _objectWithoutProperties(_ref6, ['data']);
	
	    return _react2.default.createElement(
	        Base,
	        props,
	        _react2.default.createElement(
	            Inner,
	            null,
	            _react2.default.createElement(Photo, { src: data.main_image.url }),
	            _react2.default.createElement(
	                Info,
	                { to: '/projects/' + data.slug },
	                _react2.default.createElement(
	                    _designSystem.Heading.h3,
	                    { regular: false, bold: true },
	                    data.name
	                ),
	                _react2.default.createElement(
	                    _designSystem.Text,
	                    { mt: 2 },
	                    data.tagline
	                )
	            ),
	            _react2.default.createElement(
	                Creators,
	                null,
	                data.creators.slice(0, 4).map(function (creator) {
	                    return _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/users/' + creator.username },
	                        _react2.default.createElement(_designSystem.Avatar, { src: creator.avatar_url, size: 24, key: creator.id })
	                    );
	                }),
	                data.creators.length > 4 && _react2.default.createElement(ViewAllCreators, { creators: data.creators })
	            )
	        )
	    );
	};
	
	exports.default = ProjectCard;
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    border-radius: ', ';\n    &:not(:first-of-type) {\n        margin-top: ', 'px;\n        ', ' {\n            margin-top: ', 'px;\n        }\n    }\n'], ['\n    border-radius: ', ';\n    &:not(:first-of-type) {\n        margin-top: ', 'px;\n        ', ' {\n            margin-top: ', 'px;\n        }\n    }\n']);
	
	var _reactFontawesome = __webpack_require__(25);
	
	var _designSystem = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectCard = __webpack_require__(101);
	
	var _ProjectCard2 = _interopRequireDefault(_ProjectCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Box.extend(_templateObject, function (_ref) {
	    var theme = _ref.theme;
	    return theme.radius;
	}, function (_ref2) {
	    var theme = _ref2.theme;
	    return theme.space[4];
	}, function (_ref3) {
	    var theme = _ref3.theme;
	    return theme.mediaQueries.md;
	}, function (_ref4) {
	    var theme = _ref4.theme;
	    return theme.space[5];
	});
	
	var ProjectSection = function ProjectSection(_ref5) {
	    var title = _ref5.title,
	        icon = _ref5.icon,
	        iconColor = _ref5.iconColor,
	        props = _objectWithoutProperties(_ref5, ['title', 'icon', 'iconColor']);
	
	    return _react2.default.createElement(
	        Base,
	        props,
	        _react2.default.createElement(
	            _designSystem.Heading.h2,
	            { mb: 3 },
	            _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: icon, color: (0, _designSystem.cx)(iconColor) }),
	            ' ',
	            title
	        ),
	        _react2.default.createElement(
	            _designSystem.Flex,
	            { style: { margin: '-8px' }, wrap: true },
	            _react2.default.createElement(_ProjectCard2.default, null),
	            _react2.default.createElement(_ProjectCard2.default, null),
	            _react2.default.createElement(_ProjectCard2.default, null)
	        )
	    );
	};
	
	exports.default = ProjectSection;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    border-radius: ', ';\n    overflow: hidden;\n    position: relative;\n    ', '\n'], ['\n    border-radius: ', ';\n    overflow: hidden;\n    position: relative;\n    ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.0625);\n        '], ['\n            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.0625);\n        ']);
	
	var _designSystem = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(15);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Sheet = (0, _styledComponents2.default)(_designSystem.Card.withComponent(_designSystem.Container))(_templateObject, function (_ref) {
	    var theme = _ref.theme;
	    return theme.radii[2];
	}, function (props) {
	    return !props.flat && (0, _styledComponents.css)(_templateObject2);
	});
	Sheet.defaultProps = {
	    bg: 'rgba(255, 255, 255, 0.875)',
	    color: 'black',
	    mb: 4,
	    p: [3, 4],
	    width: 1
	};
	
	Sheet.propTypes = {
	    flat: _propTypes2.default.boolean
	};
	
	exports.default = Sheet;
	module.exports = exports['default'];

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    border-radius: ', ';\n    &:not(:first-child) {\n        margin-top: ', 'px;\n    }\n'], ['\n    border-radius: ', ';\n    &:not(:first-child) {\n        margin-top: ', 'px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose([''], ['']);
	
	var _designSystem = __webpack_require__(4);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SidebarSection = _designSystem.Box.extend.attrs({ bg: 'snow', p: 3 })(_templateObject, function (_ref) {
	    var theme = _ref.theme;
	    return theme.radius;
	}, function (_ref2) {
	    var theme = _ref2.theme;
	    return theme.space[4];
	});
	
	var Sidebar = _designSystem.Box.extend(_templateObject2);
	
	exports.default = { Sidebar: Sidebar, SidebarSection: SidebarSection };
	module.exports = exports['default'];

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    text-shadow: rgba(0, 0, 0, 0.376) 0px 1px 2px;\n'], ['\n    text-shadow: rgba(0, 0, 0, 0.376) 0px 1px 2px;\n']);
	
	var _designSystem = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(32);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Badge.withComponent(_gatsbyLink2.default).extend.attrs({
	    my: 1,
	    mr: 2,
	    p: 2
	})(_templateObject);
	
	var Topic = function Topic(_ref) {
	    var data = _ref.data,
	        props = _objectWithoutProperties(_ref, ['data']);
	
	    return _react2.default.createElement(Base, _extends({ to: '/topics/' + data.slug, children: data.name, style: { background: (0, _designSystem.cx)(data.color) } }, props));
	};
	
	exports.default = Topic;
	module.exports = exports['default'];

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']);
	
	var _designSystem = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Topic = __webpack_require__(192);
	
	var _Topic2 = _interopRequireDefault(_Topic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Base = _designSystem.Box.extend.attrs({ mt: -1 })(_templateObject);
	
	var TopicList = function TopicList(_ref) {
	    var _ref$topics = _ref.topics,
	        topics = _ref$topics === undefined ? [] : _ref$topics,
	        props = _objectWithoutProperties(_ref, ['topics']);
	
	    return _react2.default.createElement(
	        Base,
	        props,
	        topics.map(function (topic) {
	            return _react2.default.createElement(_Topic2.default, { data: topic, key: topic.id });
	        })
	    );
	};
	exports.default = TopicList;
	module.exports = exports['default'];

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _designSystem = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Footer = __webpack_require__(142);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(46);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Intro = __webpack_require__(572);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _ProjectSection = __webpack_require__(576);
	
	var _ProjectSection2 = _interopRequireDefault(_ProjectSection);
	
	var _Sidebar = __webpack_require__(191);
	
	var _TopicList = __webpack_require__(193);
	
	var _TopicList2 = _interopRequireDefault(_TopicList);
	
	var _UserCard = __webpack_require__(103);
	
	var _UserCard2 = _interopRequireDefault(_UserCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var topics = ['Web', 'Mobile', 'AI', 'Virtual reality', 'Hardware', 'Blockchain', 'Big data', 'Gaming', 'Tools', 'Art'];
	
	var Index = function (_Component) {
	    _inherits(Index, _Component);
	
	    function Index() {
	        _classCallCheck(this, Index);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Index.prototype.render = function render() {
	        return _react2.default.createElement(
	            _react.Fragment,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Intro2.default, null),
	            _react2.default.createElement(
	                _designSystem.Flex,
	                { flexDirection: ['column', null, 'row'], justify: 'center', py: [4, null, 5], px: [3, null, 4] },
	                _react2.default.createElement(
	                    _designSystem.Box.main,
	                    { w: [1, null, 3 / 4] },
	                    _react2.default.createElement(_ProjectSection2.default, { title: 'Featured', icon: 'star', iconColor: 'yellow.4' }),
	                    _react2.default.createElement(_ProjectSection2.default, { title: 'Trending', icon: 'fire', iconColor: 'red.4' }),
	                    _react2.default.createElement(_ProjectSection2.default, { title: 'Recently shipped', icon: 'clock', iconColor: 'gray.4' })
	                ),
	                _react2.default.createElement(
	                    _Sidebar.Sidebar,
	                    { mt: [4, null, 0], ml: [0, null, 4], w: [1, null, 1 / 4] },
	                    _react2.default.createElement(
	                        _Sidebar.SidebarSection,
	                        null,
	                        _react2.default.createElement(
	                            _designSystem.Heading.h3,
	                            { mb: 3 },
	                            'Popular topics'
	                        ),
	                        _react2.default.createElement(_TopicList2.default, { topics: topics })
	                    ),
	                    _react2.default.createElement(
	                        _Sidebar.SidebarSection,
	                        null,
	                        _react2.default.createElement(
	                            _designSystem.Heading.h3,
	                            { mb: 3 },
	                            'Top hackers'
	                        ),
	                        _react2.default.createElement(_UserCard2.default, null),
	                        _react2.default.createElement(_UserCard2.default, null),
	                        _react2.default.createElement(_UserCard2.default, null),
	                        _react2.default.createElement(_UserCard2.default, null),
	                        _react2.default.createElement(_UserCard2.default, null)
	                    )
	                )
	            ),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return Index;
	}(_react.Component);
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-24c80623a654164e3f7d.js